import { useEffect } from 'react';
import dayjs from 'dayjs';
import { getInspectionDetailsById } from '../services/purchaseIndentService';

const usePurchaseInspectionDetailsById = ({
    id,
    approvedByHook,
    inspiredByHook,
    setOrderFromDate,
    setCustomerNotes,
    callMessage,
    setStatus,
}) => {
    useEffect(() => {
        if (!id) return;

        const fetchInspectionDetails = async () => {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_id_receives: id,
            };

            try {
                const data = await getInspectionDetailsById(para);
                if (data && data.length > 0) {
                    const record = data[0];

                    setOrderFromDate(dayjs(record.return_date));
                    setCustomerNotes(record.return_notes);

                    approvedByHook.setSelectedEmployeeID(record.id_approved_by);
                    inspiredByHook.setSelectedEmployeeID(record.id_inspected_by);

                    const approvedEmp = approvedByHook.employee.find(emp => emp.id === record.id_approved_by);
                    approvedByHook.setSelectedEmployee(approvedEmp);

                    const inspectedEmp = inspiredByHook.employee.find(emp => emp.id === record.id_inspected_by);
                    inspiredByHook.setSelectedEmployee(inspectedEmp);
                    setStatus(record.p_status);
                }
            } catch (error) {
                callMessage('error', error.message, 'Error');
            }
        };

        fetchInspectionDetails();

    }, [id, approvedByHook.employee, inspiredByHook.employee]);
};

export default usePurchaseInspectionDetailsById;
